import { useSelector } from "react-redux";
import { getLayout } from "./selectors";

export const useAccessWindowSize = () => {
	return useSelector(getLayout).toJS();
};
